module.exports = __webpack_public_path__ + "img/综合大屏有字.1b2ce038.png";